import { FiGlobe, FiSmartphone, FiCode, FiShare2 } from 'react-icons/fi';

const services = [
  {
    title: 'Web Application Pentesting',
    description: 'Comprehensive security assessment of web applications to identify and exploit vulnerabilities.',
    features: ['OWASP Top 10 Coverage', 'Business Logic Testing', 'Authentication Bypass'],
    icon: <FiGlobe className="text-white" size={20} />,
  },
  {
    title: 'Mobile App Security Testing',
    description: 'In-depth security analysis of iOS and Android applications to uncover security flaws.',
    features: ['Static & Dynamic Analysis', 'Secure Storage Testing', 'Client-Side Injection'],
    icon: <FiSmartphone className="text-white" size={20} />,
  },
  {
    title: 'API Security Assessment',
    description: 'Thorough evaluation of API endpoints to identify security vulnerabilities and weaknesses.',
    features: ['Authorization Flaws', 'Rate Limiting Bypass', 'Data Exposure Analysis'],
    icon: <FiCode className="text-white" size={20} />,
  },
  {
    title: 'Infrastructure & AD Testing',
    description: 'Comprehensive assessment of network infrastructure and Active Directory security.',
    features: ['Privilege Escalation', 'Lateral Movement', 'Domain Compromise'],
    icon: <FiShare2 className="text-white" size={20} />,
  },
];

export default function RedTeamServices() {
  return (
    <section id="services" className="bg-black text-white py-20 px-6 md:px-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold">
          Our Red Team <span className="text-red-500">Services</span>
        </h2>
        <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
          We identify vulnerabilities before malicious actors do, helping you strengthen your security posture.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map((service, index) => (
          <div key={index} className="bg-[#111] border border-gray-700 rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300" data-aos="fade-up" data-aos-delay={index * 100} data-aos-duration="800">
            <div className="bg-red-600 rounded-full w-10 h-10 flex items-center justify-center mb-4">
              {service.icon}
            </div>
            <h3 className="text-lg font-semibold mb-2">{service.title}</h3>
            <p className="text-gray-400 text-sm mb-4">{service.description}</p>
            <ul className="text-sm text-gray-300 mb-4 space-y-1">
              {service.features.map((feature, i) => (
                <li key={i} className="flex items-center gap-2">
                  <span className="text-red-500">✔</span>
                  {feature}
                </li>
              ))}
            </ul>
            <a href="#contact" className="text-red-500 text-sm font-medium inline-flex items-center hover:underline">
              Learn more <span className="ml-1">→</span>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
